export default {
    "& h1": {
        fontSize: "34px",
        mt: "30px",
        lineHeight: "36px",
    },
    "& h2": {
        fontSize: "26px",
        color: "color4",
        lineHeight: "28px",
        mt: "20px",
        mb: "4",
    },
    "& h3": {
        fontSize: "22px",
        lineHeight: "24px",
        color: "color1",
        mt: "20px",
    },
    "& h4": {
        fontSize: "18px",
        lineHeight: "20px",
        color: "color4",
        mt: "20px",
    },
    "& p": {
        fontSize: "18px",
        fontWeight: 400,
        lineHeight: "24px",
        mt: "10px",
    },
    "& a": {
        textDecoration: "none",
        color: "color1",
    },
    "& hr": {
        mt: "30px",
        borderColor: "color2",
    },
    "& ul": {
        pl: "20px",
        mt: "15px",
        "& ul": {
            mb: "15px",
        },
        fontSize: "18px",
        lineHeight: "26px",
        //listStyle: "none",
    },
    "& ul.two-col": {
        columns: 2,
        "& li": {
            mt: "0px",
            pageBreakInside: "avoid",
            breakInside: "avoid-column",
        },
    },
    "& .fontLarge": {
        fontSize: "xl",
    },
    "& .textCenter, & .align-center": {
        textAlign: "center",
    },
    "& .colorPrimary": {
        color: "color1",
    },
    "& .btn": {
        display: "inline-block",
        padding: "1rem 2rem",
        marginBottom: "5px",
        color: "white",
        backgroundColor: "color1",
        _hover: {
            backgroundColor: "color4",
            cursor: "pointer",
        },
    },
    "& .btn--large": {
        padding: "25px 100px",
        fontSize: "18px",
        textTransform: "uppercase",
    },
    "& .btn--yellow": {
        backgroundColor: "yellow",
        color: "black",
        "& a": {
            color: "black",
        },
    },
    "& table": {
        width: "100%",
        "& tr": {
            borderBottom: "1px solid #fff",
            "& td": {
                pb: "15px",
            },
        },
        "& td": {
            "&.center": { textAlign: "center" },
            "&.alignTop": { verticalAlign: "top", "& p:first-child": { mt: "0px" } },
            "&.p15": { padding: "15px" },
            "&.pl30": { paddingLeft: "30px" },
            "&.p30": { padding: "30px" },
            "&.w20": { width: "20%" },
            "&.w40": { width: "40%" },
            "&.bg20": { backgroundColor: "rgba(255,255,255,0.2)" },
            "&.bg40": { backgroundColor: "rgba(255,255,255,0.4)" },
            "&.dim": { color: "rgba(255,255,255,0.2)" },
        },
        "&.table--plain": {
            "& tr": {
                border: "none",
            },
            "& td": {
                border: "none",
            },
        },
    },
    "& .table--ScrollWrapper": {
        overflowX: "auto",
        position: "relative",
        "& > table": {
            minWidth: "600px",
        },
    },
    "& .table--centered": {
        "& td": {
            textAlign: "center",
        },
    },
    "& .table--centeredExceptFirst": {
        "& td:not(:first-of-type)": {
            textAlign: "center",
        },
    },
    "& .table--borders": {
        border: "1px solid #fff",
        "& td": {
            borderRight: "1px solid #fff",
            padding: "20px",
            verticalAlign: "top",
            "& p": {
                m: 0,
            },
        },
    },
    "& .table--colorheader": {
        "& th": {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "color13",
            padding: "20px",
            verticalAlign: "top",
            fontWeight: "500",
            backgroundColor: "color4",
            color: "white",
            "& p": {
                m: 0,
            },
        },
    },
    "& .table--sm": {
        "& th": {
            fontSize: "14px",
            padding: "10px",
        },
        "& td": {
            fontSize: "14px",
            padding: "5px",
            verticalAlign: "middle",
        },
    },

    "& .notebox": {
        padding: "20px",
        border: "1px solid #fff",
        "& *:first-child": {
            marginTop: "0px",
        },
    },
    "&.colorMode--light": {
        color: "#333",
        "& a": {
            color: "color1",
        },
        "& h2": {
            color: "color2",
        },
        "& h3": {
            color: "color3",
        },
        "&.btn": {
            color: "white",
        },
        "& table": {
            "&.table--plain": {
                "& tr": { border: "none" },
                "& td": { border: "none" },
            },
        },
        "& .table--borders": {
            border: "1px solid #333",
            "& td": {
                borderRight: "1px solid #333",
                borderBottom: "1px solid #333",
                borderColor: "#333",
            },
        },
        "& .table--light": {
            borderColor: "color7",
            backgroundColor: "color10",
            "& td, & tr": {
                borderColor: "color7",
            },
        },

        "& .notebox": {
            border: "1px solid #000",
        },
    },
    "& .logo-list": {
        display: "flex",
        flexWrap: "wrap",
        listStyle: "none",
        margin: "0 0 0 -20px",
        padding: 0,
        alignItems: "center",
        maxWidth: "1100px",
        "& li": {
            maxWidth: "250px",
            padding: "20px",
        },
    },
    "& .iconTable": {
        color: "color10",
        margin: "20px 0",
    },
    "& .iconTable_row": {
        backgroundColor: "color9",
        marginBottom: 1,
        display: "flex",
        flexDirection: "column",
    },
    "& .iconTable_iconCell": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    "& .iconTable_iconCell img": {
        width: "100px",
        height: "100px",
    },
    "& .iconTable_textCell": {
        padding: "20px",
        "& a": {
            color: "color3",
        },
    },
    "& .iconTable_textCell h4": {
        marginTop: 0,
        color: "color2",
    },
    "@media screen and (min-width: 768px)": {
        "& .iconTable_row": {
            flexDirection: "row",
        },
        "& .iconTable_iconCell": {
            width: "12.5%",
        },
        "& .iconTable_textCell": {
            paddingLeft: "0",
        },
    },
    "& .colorPalette": {
        display: "flex",
        flexWrap: "wrap",
        "& > div": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100px",
            height: "100px",
            color: "#fff",
            marginRight: "5px",
            marginBottom: "5px",
        },
    },
    "& .chakra-tabs": {
        "& .body": {
            padding: 0,
            "& p": {
                maxW: "100%",
            },
            "& h2": {
                color: "color1",
                mt: "45px",
            },
            "& .btn": {
                backgroundColor: "color1",
                padding: ".5rem",
                _hover: {
                    backgroundColor: "color2",
                },
            },
            "& ul li::before": {
                content: '"\\2022\\00a0"',
                color: "color2",
                fontWeight: "bold",
                display: "inline-block",
                width: "2em",
                marginLeft: "-1em",
            },
            "& ul li ul li::before": {
                content: '"-"',
                color: "color2",
            },
        },
        "& .chakra-accordion": {
            "& .accordion-label": {
                color: "#333",
            },
            "& .chakra-accordion__item ": {
                borderColor: "color5",
            },
        },
    },
}
